// extracted by mini-css-extract-plugin
export default {"ontarioEligibilityIcon":"OntarioHealthInsurancePlanEligibilityIndicator_ontarioEligibilityIcon__Lxz0d"};